// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresPoolGetBody = {
  poolId: string;
};

export type typeSquaresPoolGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    season?: {
      squaresSeasonId: string;
      seasonNumber: number;
      gridType: "classic" | "shared";
      leagueKey: string;
      gameRule: {
        presetKey:
          | "oneGame"
          | "allGames"
          | "tnf"
          | "snf"
          | "mnf"
          | "thanksgiving"
          | "christmas"
          | "playoffs"
          | "conference"
          | "team"
          | "bowls"
          | "cfp"
          | "ncaaTournament"
          | "conferenceTournaments"
          | "openingDay"
          | "worldSeries"
          | "matchdayRange"
          | "customDates";
        seasonYear?: number | null;
        eventId?: string | null;
        teamId?: string | null;
        conferenceKey?: string | null;
        customDates?: {
          mode: "range" | "dates";
          fromDay?: string;
          toDay?: string;
          days?: string[];
        } | null;
        excludedEventIds: string[];
      };
      gamesLabel: string;
      gamesWindowLabel?: string | null;
      gameCount: number;
      axes: {
        kind:
          "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
        topLabel?: string | null;
        sideLabel?: string | null;
        teamId?: string | null;
      };
      checkpoints: {
        checkpointKey:
          | "q1"
          | "half"
          | "q3"
          | "p1"
          | "p2"
          | "after3"
          | "after5"
          | "after7"
          | "final";
        label: string;
      }[];
      gridSettings: {
        size: number;
        maxPerMember?: number | null;
        autoLock: boolean;
        showNumbers: boolean;
      };
      newGrid: {
        carrySquares: boolean;
        redrawNumbers: boolean;
        autoPublish: boolean;
      };
      isFrozen: boolean;
      frozenFields: string[];
      canStartNewSeason: boolean;
    } | null;
    grids: {
      gridId: string;
      sequence: number;
      label: string;
      origin: "setup" | "rule" | "manual";
      publishStatus: "draft" | "published";
      gridState: "open" | "locked" | "live" | "final" | "void";
      eventId?: string | null;
      eventCount: number;
      kickoffAt?: string | null;
      lockAt?: string | null;
      mySquareCount: number;
      homeTeamId?: string | null;
      awayTeamId?: string | null;
      roundLabel?: string | null;
      customTitle?: string | null;
    }[];
    currentGridId?: string | null;
    emptyState: "none" | "noSeason" | "awaitingSchedule";
    viewer: { canManage: boolean; maxPerMember?: number | null };
  };
};

export type typeSquaresPoolGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPoolGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPoolGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresPoolGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresPoolGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresPoolGetBody);
  }

  return async function postSquaresPoolGet(
    payload: typeSquaresPoolGetBody,
  ): Promise<typeSquaresPoolGetOutput200 | typeSquaresPoolGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresPoolGet" failed before calling the network. #709c9af053ee`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#709c9af053ee" },
        },
        data: null,
      } as typeSquaresPoolGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/pool-get`,
      httpMethod: "POST",
      options,
    })) as typeSquaresPoolGetOutput200 | typeSquaresPoolGetOutput400;
  };
}
